import { Outlet } from '@tanstack/react-router';

/** Outermost layout. Every route renders inside it, authenticated or not. */
export function RootLayout() {
  return (
    <div className="min-h-dvh bg-neutral-50 text-neutral-900">
      <Outlet />
    </div>
  );
}
